"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissions = exports.resetResendMail = exports.deactivateAccount = exports.resetErrors = exports.reset = exports.isAuthenticated = exports.sendAccountActivationInstructions = exports.sendPasswordResetInstructions = exports.logout = exports.loginWithTokenWithProvider = exports.login = exports.getAccount = exports.CHECK_SESSION = void 0;
var authentication_1 = require("@pbl/pbl-react-core/lib/models/authentication");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var lodash_1 = __importDefault(require("lodash"));
var auth_service_1 = require("../../../utils/auth-service");
var framework_1 = require("../../../widgets/framework");
var action_type_util_1 = require("../../action-type.util");
var actions_1 = require("../account-reactivation/actions");
var actions_2 = require("../app/actions");
var actions_3 = require("../profile/actions");
exports.CHECK_SESSION = 'authentication/CHECK_SESSION';
var getAccount = function () { return ({
    type: authentication_1.GET_ACCOUNT,
    payload: services_1.ProfileService.getProfileV2()
}); };
exports.getAccount = getAccount;
var login = function (username, password, rememberMe, successCallback, errorCallback) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, account, access_token, refresh_token, decodedToken, userData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, 8, 9]);
                    dispatch({
                        type: (0, action_type_util_1.REQUEST)(authentication_1.LOGIN)
                    });
                    dispatch((0, actions_2.toggleLoading)({ spinning: true }));
                    return [4, auth_service_1.AuthService.login({ username: username, password: password, rememberMe: rememberMe })];
                case 1:
                    payload = _a.sent();
                    return [4, services_1.SessionService.status()];
                case 2:
                    _a.sent();
                    return [4, dispatch((0, exports.getAccount)(payload === null || payload === void 0 ? void 0 : payload.access_token))];
                case 3:
                    _a.sent();
                    account = getState().authentication.account;
                    if (!!lodash_1.default.some(lodash_1.default.values(account), function (val) { return !lodash_1.default.isEmpty(val); })) return [3, 4];
                    loginError(new Error('profile not found'), dispatch, true, errorCallback);
                    return [3, 6];
                case 4:
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)(authentication_1.LOGIN),
                        payload: payload
                    });
                    try {
                        dispatch((0, exports.getPermissions)());
                    }
                    catch (e) {
                        console.error('Error getting the user permissions', e);
                    }
                    try {
                        dispatch((0, actions_3.fetchTermsAndConditions)());
                    }
                    catch (e) {
                        console.error('Error getting the user terms and conditions', e);
                    }
                    access_token = payload.access_token, refresh_token = payload.refresh_token;
                    decodedToken = auth_service_1.AuthService.decodeToken(access_token);
                    auth_service_1.AuthService.updateLocalStorage(access_token, refresh_token, decodedToken.login, username);
                    return [4, auth_service_1.AuthService.checkSession()];
                case 5:
                    _a.sent();
                    userData = {
                        email: decodedToken.email,
                        uid: decodedToken.login
                    };
                    framework_1.GoFwInternalInstance === null || framework_1.GoFwInternalInstance === void 0 ? void 0 : framework_1.GoFwInternalInstance.onSessionStatusUpdate({
                        isValid: !!access_token,
                        sessionToken: access_token
                    });
                    dispatch({
                        type: authentication_1.GET_USER,
                        payload: userData
                    });
                    successCallback();
                    dispatch((0, actions_2.clearMessages)());
                    _a.label = 6;
                case 6: return [3, 9];
                case 7:
                    e_1 = _a.sent();
                    loginError(e_1, dispatch, false, errorCallback);
                    return [3, 9];
                case 8:
                    dispatch((0, actions_2.toggleLoading)({ spinning: false }));
                    return [7];
                case 9: return [2];
            }
        });
    }); };
};
exports.login = login;
var loginWithTokenWithProvider = function (body, provider, successCallback, errorCallback) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(authentication_1.LOGIN)
                });
                dispatch((0, actions_2.toggleLoading)({ spinning: true }));
                setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                    var payload, access_token, refresh_token, decodedToken, account, e_2, userData, e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 11, 12, 13]);
                                return [4, auth_service_1.AuthService.loginWithTokenWithProvider(body, provider)];
                            case 1:
                                payload = _a.sent();
                                if (!(payload === null || payload === void 0 ? void 0 : payload.access_token)) {
                                    loginError(new Error('authentication failed'), dispatch, true, errorCallback);
                                    return [2];
                                }
                                access_token = payload.access_token, refresh_token = payload.refresh_token;
                                decodedToken = auth_service_1.AuthService.decodeToken(access_token);
                                auth_service_1.AuthService.updateLocalStorage(access_token, refresh_token, decodedToken.login, decodedToken.login);
                                return [4, services_1.SessionService.status()];
                            case 2:
                                _a.sent();
                                return [4, auth_service_1.AuthService.checkSession()];
                            case 3:
                                _a.sent();
                                return [4, dispatch((0, exports.getAccount)())];
                            case 4:
                                _a.sent();
                                account = getState().authentication.account;
                                if (!!lodash_1.default.some(lodash_1.default.values(account), function (val) { return !lodash_1.default.isEmpty(val); })) return [3, 5];
                                loginError(new Error('profile not found'), dispatch, true, errorCallback);
                                return [3, 10];
                            case 5:
                                dispatch({
                                    type: (0, action_type_util_1.SUCCESS)(authentication_1.LOGIN),
                                    payload: payload
                                });
                                _a.label = 6;
                            case 6:
                                _a.trys.push([6, 8, , 9]);
                                return [4, dispatch((0, exports.getPermissions)())];
                            case 7:
                                _a.sent();
                                return [3, 9];
                            case 8:
                                e_2 = _a.sent();
                                console.error('Error getting the user permissions', e_2);
                                return [3, 9];
                            case 9:
                                userData = {
                                    email: decodedToken.email,
                                    uid: decodedToken.login
                                };
                                framework_1.GoFwInternalInstance === null || framework_1.GoFwInternalInstance === void 0 ? void 0 : framework_1.GoFwInternalInstance.onSessionStatusUpdate({
                                    isValid: !!access_token,
                                    sessionToken: access_token
                                });
                                dispatch({
                                    type: authentication_1.GET_USER,
                                    payload: userData
                                });
                                successCallback(payload);
                                dispatch((0, actions_2.clearMessages)());
                                _a.label = 10;
                            case 10: return [3, 13];
                            case 11:
                                e_3 = _a.sent();
                                loginError(e_3, dispatch, false, errorCallback);
                                return [3, 13];
                            case 12:
                                dispatch((0, actions_2.toggleLoading)({ spinning: false }));
                                return [7];
                            case 13: return [2];
                        }
                    });
                }); }, 500);
            }
            catch (e) {
                loginError(e, dispatch, false, errorCallback);
                dispatch((0, actions_2.toggleLoading)({ spinning: false }));
            }
            return [2];
        });
    }); };
};
exports.loginWithTokenWithProvider = loginWithTokenWithProvider;
var loginError = function (e, dispatch, isProfileEmpty, errorCallback) {
    dispatch({
        type: (0, action_type_util_1.FAILURE)(authentication_1.LOGIN),
        payload: e
    });
    if (isProfileEmpty) {
        dispatch((0, actions_2.showMessageBar)({
            message: 'error.uaaAuthentication.emptyProfile',
            type: 'error'
        }));
    }
    else if (e.payload && e.payload.additionalInformation) {
        var errorKey = e.payload.additionalInformation.errorKey;
        var message = e.payload.additionalInformation.message;
        switch (errorKey) {
            case 'error.uaaAuthentication.notActivated':
                dispatch((0, actions_2.showMessageBar)({
                    message: 'error.uaaAuthentication.notActivated',
                    type: 'error'
                }));
                break;
            case 'error.uaaAuthentication.lockout':
                dispatch(showAccountLockedMessage());
                break;
            case 'error.uaaAuthentication.lockoutAttempt':
                dispatch(showAccountLockedAttemptMessage());
                break;
            case 'error.uaaAuthentication.warning':
                var remainingAuthAttempts = e.payload.additionalInformation.remainingAuthAttempts;
                dispatch((0, actions_2.showMessageBar)({
                    message: 'error.uaaAuthentication.warning',
                    type: 'warning',
                    messageParams: { remainingAuthAttempts: remainingAuthAttempts }
                }));
                break;
            case 'error.uaaAuthentication.suspended':
                dispatch((0, actions_1.reactivateAccount)(true));
                break;
            case 'error.uaaAuthentication.invalid':
            default:
                if (message && message === 'error.uaaAuthentication.lockout') {
                    dispatch(showAccountLockedMessage());
                }
                else {
                    dispatch((0, actions_2.showMessageBar)({
                        message: 'error.uaaAuthentication.invalid',
                        type: 'error'
                    }));
                }
                break;
        }
    }
    else {
        dispatch((0, actions_2.showMessageBar)({
            message: 'error.general',
            type: 'error'
        }));
    }
    if (errorCallback) {
        errorCallback();
    }
};
var logout = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, 4, 6]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)('authentication/LOGOUT')
                });
                return [4, auth_service_1.AuthService.logout()];
            case 1:
                _b.sent();
                return [4, services_1.SessionService.status()];
            case 2:
                _b.sent();
                return [3, 6];
            case 3:
                e_4 = _b.sent();
                dispatch((0, actions_2.showMessageBar)({ message: (_a = e_4.payload) === null || _a === void 0 ? void 0 : _a.error, type: 'error', messageTimeout: 10000 }));
                return [3, 6];
            case 4:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)('authentication/LOGOUT')
                });
                return [4, dispatch((0, exports.reset)())];
            case 5:
                _b.sent();
                auth_service_1.AuthService.removeLocalStorage();
                return [7];
            case 6: return [2];
        }
    });
}); }; };
exports.logout = logout;
var sendPasswordResetInstructions = function (emailAddress) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, e_5, message;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, services_1.AccountService.sendPasswordResetInstructions(emailAddress)];
            case 1:
                payload = _b.sent();
                dispatch((0, actions_2.clearMessages)());
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(authentication_1.SEND_PASSWORD_RESET_INSTRUCTIONS),
                    payload: payload
                });
                return [3, 3];
            case 2:
                e_5 = _b.sent();
                if ((_a = e_5 === null || e_5 === void 0 ? void 0 : e_5.payload) === null || _a === void 0 ? void 0 : _a.errorKey) {
                    message = e_5.payload.errorKey;
                    switch (message) {
                        case 'error.uaaUser.resetPasswordLockout':
                            dispatch(showAccountLockedMessage());
                            break;
                        case 'error.uaaUser.resetPasswordSuspended':
                            dispatch(showAccountSuspendedMessage());
                            break;
                        case 'error.email.notfound':
                            dispatch(showEmailNotFoundMessage());
                            break;
                        default:
                            break;
                    }
                }
                else {
                    dispatch(showUnknownErrorMessage());
                }
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.sendPasswordResetInstructions = sendPasswordResetInstructions;
var sendAccountActivationInstructions = function (emailAddress) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_6, message;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4, services_1.AccountService.sendAccountActivationInstructions(emailAddress)];
            case 1:
                _b.sent();
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(authentication_1.SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS),
                    payload: emailAddress
                });
                return [3, 3];
            case 2:
                e_6 = _b.sent();
                if ((_a = e_6 === null || e_6 === void 0 ? void 0 : e_6.payload) === null || _a === void 0 ? void 0 : _a.errorKey) {
                    message = e_6.payload.errorKey;
                    switch (message) {
                        case 'error.uaaUser.registerLockout':
                            dispatch(showAccountLockedMessage());
                            break;
                        case 'error.uaaUser.registerSuspended':
                            dispatch(showAccountSuspendedMessage());
                            break;
                        case 'error.email.notfound':
                            dispatch(showEmailNotFoundMessage());
                            break;
                        default:
                            break;
                    }
                }
                else {
                    dispatch(showUnknownErrorMessage());
                }
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.sendAccountActivationInstructions = sendAccountActivationInstructions;
var isAuthenticated = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var response, isAuthenticatedAccount, isForbiddenAccount, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                dispatch((0, actions_2.toggleLoading)({ spinning: true }));
                dispatch({
                    type: (0, action_type_util_1.REQUEST)('authentication/SESSION_CHECK')
                });
                return [4, auth_service_1.AuthService.checkSession()];
            case 1:
                response = _a.sent();
                if (response !== null) {
                    isAuthenticatedAccount = response.status && response.status === 200;
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)('authentication/SESSION_CHECK'),
                        payload: isAuthenticatedAccount
                    });
                    isForbiddenAccount = response.status && response.status === 403;
                    if (isForbiddenAccount) {
                        dispatch((0, exports.logout)());
                    }
                    return [2, isAuthenticatedAccount];
                }
                else {
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)('authentication/SESSION_CHECK'),
                        payload: false
                    });
                }
                return [3, 4];
            case 2:
                e_7 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)('authentication/SESSION_CHECK'),
                    payload: false
                });
                return [3, 4];
            case 3:
                dispatch((0, actions_2.toggleLoading)({ spinning: false }));
                return [7];
            case 4: return [2];
        }
    });
}); }; };
exports.isAuthenticated = isAuthenticated;
var reset = function () { return function (dispatch) {
    dispatch({
        type: authentication_1.RESET_AUTHENTICATION
    });
}; };
exports.reset = reset;
var resetErrors = function () { return function (dispatch) {
    dispatch({
        type: authentication_1.CLEAR_AUTHENTICATION_ERROR
    });
}; };
exports.resetErrors = resetErrors;
var deactivateAccount = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                dispatch((0, actions_2.clearMessages)());
                dispatch((0, actions_2.toggleLoading)({ spinning: true }));
                return [4, services_1.AccountService.deactivateAccount()];
            case 1:
                _a.sent();
                return [4, dispatch((0, exports.logout)())];
            case 2:
                _a.sent();
                dispatch((0, actions_2.showMessageBar)({ message: 'account.deactivate.confirmationMsg' }));
                return [3, 5];
            case 3:
                e_8 = _a.sent();
                dispatch((0, actions_2.showMessageBar)({ message: e_8.payload.title, type: 'error' }));
                return [3, 5];
            case 4:
                dispatch((0, actions_2.clearLoading)());
                return [7];
            case 5: return [2];
        }
    });
}); }; };
exports.deactivateAccount = deactivateAccount;
var showAccountLockedMessage = function () {
    return (0, actions_2.showMessageBar)({
        message: 'account.locked',
        type: 'error'
    });
};
var showAccountLockedAttemptMessage = function () {
    return (0, actions_2.showMessageBar)({
        message: 'account.lockedAttempt',
        type: 'error'
    });
};
var showAccountSuspendedMessage = function () {
    return (0, actions_2.showMessageBar)({
        message: 'account.suspended',
        type: 'error'
    });
};
var showEmailNotFoundMessage = function () {
    return (0, actions_2.showMessageBar)({
        message: 'account.emailNotFound',
        type: 'error'
    });
};
var showUnknownErrorMessage = function () {
    return (0, actions_2.showMessageBar)({
        message: 'error.general',
        type: 'error'
    });
};
var resetResendMail = function () { return function (dispatch) {
    dispatch({
        type: 'RESET_RESEND_EMAIL_ACTIVATION'
    });
}; };
exports.resetResendMail = resetResendMail;
var getPermissions = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: 'authentication/SESSION_PERMISSIONS',
            payload: auth_service_1.AuthService.getPermissions()
        });
        return [2];
    });
}); }; };
exports.getPermissions = getPermissions;
//# sourceMappingURL=actions.js.map